export const COMPANY_NAME_IN_USE = 'ascend'
export const URL_ROOT = `${COMPANY_NAME_IN_USE}messaging.org`
export const HELP_EMAIL = `help@${URL_ROOT}`
